import { balance, importeDe, nivel } from './dominio.js';
import { MESES, anioActual, cap, eur, eurK, fecha, num } from './formato.js';
import { db } from '../data/db.js';

/* =====================================================================
   COMPONENTES
   ===================================================================== */
export const MARCA = (inv=false, tag=true) => `
<div class="marca ${inv?'inv':''}">
  <svg width="30" height="30" viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <circle cx="7" cy="8" r="5.4" fill="${inv?'#fff':'#1A4E82'}"/>
    <path d="M13.5 8h6M17.5 5.5 20.5 8l-3 2.5" stroke="${inv?'#fff':'#1A4E82'}" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
    <rect x="21.5" y="2.5" width="9" height="11" rx="1.6" stroke="#0FA37B" stroke-width="1.8"/>
    <path d="M24 6.5h4M24 9h4" stroke="#0FA37B" stroke-width="1.5" stroke-linecap="round"/>
    <rect x="1.5" y="18.5" width="9" height="11" rx="1.6" stroke="${inv?'#fff':'#1A4E82'}" stroke-width="1.8"/>
    <path d="M4 22.5h4M4 25h4" stroke="${inv?'#fff':'#1A4E82'}" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M18.5 24h-6M14.5 21.5 11.5 24l3 2.5" stroke="${inv?'#fff':'#1A4E82'}" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="25.5" cy="24" r="5.4" stroke="#0FA37B" stroke-width="1.8"/>
    <path d="M23.5 25.5v-2M25.5 25.5v-4M27.5 25.5v-3" stroke="#0FA37B" stroke-width="1.6" stroke-linecap="round"/>
  </svg>
  <div><div class="wordmark"><span class="g">Ges</span><span class="c">Con</span><span class="version">1.15</span></div>
  ${tag?'<div class="tag2">Seguimiento de contratos</div>':''}</div>
</div>`;

export function tramo(b, mini=false){
  const n = nivel(b.pct), w = Math.min(b.pct,100);
  return `<div>
    <div class="tramo ${mini?'mini':''}">
      <div class="hito" style="left:25%"></div><div class="hito" style="left:50%"></div><div class="hito" style="left:75%"></div>
      <div class="via ${n==='ok'?'':n}" style="width:${w}%"><div class="eje" style="left:8px;right:8px"></div></div>
      <div class="pk" style="left:calc(${w}% - 1px)"></div>
    </div>
    <div class="tramo-pie">
      <span><b class="mono">${num(b.pct,1)} %</b> consumido · ${eurK(b.consumido)}</span>
      <span>Saldo <b class="mono">${eurK(b.saldo)}</b> de ${eurK(b.contrato.adjudicado)}</span>
    </div></div>`;
}

export const cifra = (l,v,d,clase='') =>
  `<div class="cifra"><div class="l">${l}</div><div class="v ${clase}">${v}</div>${d?`<div class="d">${d}</div>`:''}</div>`;
export const tagEstado = e => `<span class="tag t-${e}"><span class="punto"></span>${cap(e)}</span>`;

export const ICONOS = {
  'Foto':'M3 5h18v14H3zM3 16l5-5 4 4 3-3 6 6','Albarán':'M6 3h9l4 4v14H6zM15 3v4h4M9 12h7M9 16h5',
  'Factura':'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6','Parte de trabajo':'M4 5h16v16H4zM8 3v4M16 3v4M4 10h16M8 14h3M8 17h6',
  'Pliego':'M6 3h9l4 4v14H6zM15 3v4h4M9 12h7M9 16h7','Acta':'M6 3h9l4 4v14H6zM15 3v4h4M9 13h7',
  'Certificado':'M12 3l2.5 5 5.5.8-4 3.9.9 5.5L12 15.5 7.1 18.2l.9-5.5-4-3.9L9.5 8z','Otro':'M6 3h9l4 4v14H6zM15 3v4h4'
};
export const iconoDoc = t => `<svg viewBox="0 0 24 24" fill="none" stroke="var(--azul)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="${ICONOS[t]||ICONOS['Otro']}"/></svg>`;

/* ---------- Gráficos ---------- */
export function graficoAcumulado(cid){
  const b = balance(cid), porMes = {};
  b.imputaciones.forEach(i=>{ const k=i.fecha.slice(0,7); porMes[k]=(porMes[k]||0)+importeDe(i); });
  const keys = Object.keys(porMes).sort();
  if(!keys.length) return `<div class="vacio"><h4>Sin datos todavía</h4><p>Registra la primera imputación para ver la curva.</p></div>`;
  let acc=0; const pts = keys.map(k=>{acc+=porMes[k]; return {k, acc};});
  const W=620,H=234,ml=64,mr=16,mt=16,mb=36, iw=W-ml-mr, ih=H-mt-mb;
  const max = Math.max(b.contrato.adjudicado, acc)*1.06;
  const x = i => ml + (pts.length===1?iw/2:(i/(pts.length-1))*iw);
  const y = v => mt + ih - (v/max)*ih;
  const linea = pts.map((p,i)=>`${i?'L':'M'}${x(i).toFixed(1)},${y(p.acc).toFixed(1)}`).join(' ');
  const area = `${linea} L${x(pts.length-1).toFixed(1)},${mt+ih} L${x(0).toFixed(1)},${mt+ih} Z`;
  const yAdj = y(b.contrato.adjudicado);
  const salto = pts.length>10 ? 2 : 1;
  return `<svg class="chart" viewBox="0 0 ${W} ${H}" role="img" aria-label="Gasto acumulado frente al importe adjudicado">
    <defs><linearGradient id="ga${cid}" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#0FA37B" stop-opacity=".26"/><stop offset="100%" stop-color="#0FA37B" stop-opacity="0"/></linearGradient></defs>
    ${[0,.25,.5,.75,1].map(f=>{const v=max*f;return `<line x1="${ml}" y1="${y(v)}" x2="${W-mr}" y2="${y(v)}" stroke="#DCE3EA"/>
      <text x="${ml-8}" y="${y(v)+4}" text-anchor="end" font-size="10" fill="#8496A6" font-family="IBM Plex Mono">${eurK(v)}</text>`;}).join('')}
    <path d="${area}" fill="url(#ga${cid})"/>
    <path d="${linea}" fill="none" stroke="#0FA37B" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round"/>
    <line x1="${ml}" y1="${yAdj}" x2="${W-mr}" y2="${yAdj}" stroke="#B3382C" stroke-width="1.6" stroke-dasharray="6 4"/>
    <text x="${W-mr}" y="${yAdj-7}" text-anchor="end" font-size="10.5" fill="#B3382C" font-weight="600" font-family="IBM Plex Sans">Adjudicado ${eurK(b.contrato.adjudicado)}</text>
    ${pts.map((p,i)=>`<circle cx="${x(i)}" cy="${y(p.acc)}" r="3" fill="#fff" stroke="#0FA37B" stroke-width="2"><title>${MESES[+p.k.slice(5)-1]} ${p.k.slice(0,4)}: ${eur(p.acc)}</title></circle>`).join('')}
    ${pts.map((p,i)=> i%salto===0 ? `<text x="${x(i)}" y="${H-15}" text-anchor="middle" font-size="9.5" fill="#8496A6" font-family="IBM Plex Mono">${MESES[+p.k.slice(5)-1]}</text>` : '').join('')}
    ${pts.map((p,i)=> (p.k.slice(5)==='01'||i===0) ? `<text x="${x(i)}" y="${H-3}" text-anchor="middle" font-size="9" fill="#C2CCD6" font-family="IBM Plex Mono">${p.k.slice(0,4)}</text>` : '').join('')}
  </svg>
  <div class="leyenda"><span><i style="background:#0FA37B"></i>Gasto acumulado</span><span><i style="background:#B3382C"></i>Importe de adjudicación</span></div>`;
}

export function graficoMensual(cid){
  const imps = db.imputaciones.filter(i=>i.contrato===cid && +i.fecha.slice(0,4)===anioActual);
  const porMes = {};
  imps.forEach(i=>{ const k=i.fecha.slice(0,7); porMes[k]=(porMes[k]||0)+importeDe(i); });
  const keys = Object.keys(porMes).sort();
  if(!keys.length) return '<div class="vacio"><p>Sin imputaciones en este ejercicio.</p></div>';
  const W=620,H=200,ml=64,mr=16,mt=14,mb=28, iw=W-ml-mr, ih=H-mt-mb;
  const max = Math.max(...keys.map(k=>porMes[k]))*1.15;
  const paso = iw/keys.length, bw = Math.min(38, paso*.62);
  return `<svg class="chart" viewBox="0 0 ${W} ${H}" role="img" aria-label="Gasto mensual del ejercicio">
    ${[0,.5,1].map(f=>`<line x1="${ml}" y1="${mt+ih-f*ih}" x2="${W-mr}" y2="${mt+ih-f*ih}" stroke="#DCE3EA"/>
      <text x="${ml-8}" y="${mt+ih-f*ih+4}" text-anchor="end" font-size="10" fill="#8496A6" font-family="IBM Plex Mono">${eurK(max*f)}</text>`).join('')}
    ${keys.map((k,i)=>{const h=(porMes[k]/max)*ih, cx=ml+paso*i+paso/2;
      return `<rect x="${cx-bw/2}" y="${mt+ih-h}" width="${bw}" height="${h}" rx="2" fill="#2C6FB0"><title>${MESES[+k.slice(5)-1]}: ${eur(porMes[k])}</title></rect>
      <text x="${cx}" y="${H-9}" text-anchor="middle" font-size="10" fill="#8496A6" font-family="IBM Plex Mono">${MESES[+k.slice(5)-1]}</text>`;}).join('')}
  </svg>`;
}

